// *********************************************************************
//      LPGA Form Redirection
// *********************************************************************
$(document).ready(function() {

// Add an event listener for the 'keypress' event
    $(document).keyup('#91299-name-1', function(event){
      $('.cartname').remove();
      var namevalue = $("#91299-name-1").val();
      $('<input type="hidden" name="properties[name]" class="cartname" value="'+namevalue+'" />').appendTo('.product-info__buy-buttons > .shopify-product-form');

});




$(document).on("change", "#91299-file-1", function() {        // Get the selected file
        var file = this.files[0];

        if (file) {
          // Display the preview of the selected image
          $('#previewImage').attr('src', URL.createObjectURL(file)).show();
 var newFileInput = $('<input type="file" name="properties[logoimg]" class="cartlogo" style="display:none;"/>').appendTo('.product-info__buy-buttons > .shopify-product-form');

          // Clone the selected file to fileInput2
          var clone = this.cloneNode(true);
                    clone.name = 'properties[logoimage]'; // Update the name of the clone
                    clone.class = 'cartlogo'; // Update the name of the clone

          $(clone).css('display', 'none'); // Set display: none on the clone

          $('.cartlogo').replaceWith(clone);
            $('.cartlogo').css('display', 'none'); // Set display: none on fileInput2


          // Reset the value of fileInput1 to allow selecting the same file again
        }
      });

      // Handle the file input change event for fileInput2
      $('.cartlogo').on('change', function() {
        // Perform your logic for the second file input
        console.log('Selected files for fileInput2:', this.files);
      });


 $(document).keyup('#91299-text-1', function(event){
      $('.cartfirst').remove();
      var namevalue = $("#91299-text-1").val();
      $('<input type="hidden" name="properties[firstname]" class="cartfirst" value="'+namevalue+'" />').appendTo('.product-info__buy-buttons > .shopify-product-form');

});
  $(document).keyup('#91299-text-2', function(event){
      $('.cartlast').remove();
      var namevalue = $("#91299-text-2").val();
      $('<input type="hidden" name="properties[lastname]" class="cartlast" value="'+namevalue+'" />').appendTo('.product-info__buy-buttons > .shopify-product-form');

});
$(document).keyup('#91299-email-1', function(event){
      $('.cartemail').remove();
      var namevalue = $("#91299-email-1").val();
      $('<input type="hidden" name="properties[email]" class="cartemail" value="'+namevalue+'" />').appendTo('.product-info__buy-buttons > .shopify-product-form');

});
  $(document).keyup('#91299-phone-1', function(event){
      $('.cartphone').remove();
      var namevalue = $("#91299-phone-1").val();
      $('<input type="hidden"  name="properties[phone]" class="cartphone" value="'+namevalue+'" />').appendTo('.product-info__buy-buttons > .shopify-product-form');

});
});
window.addEventListener(
  "formdata",
  function (event) {
    
    // $(document).ready(function () {
    //   $(".wizard__submit").trigger("click");
    // });
    
    if (event && event.formData.get("radio-1") && event.formData.get("radio-1").toLowerCase() == "amateur") {
      window.location = "https://orca-golf.com/pages/lpga-amateurs";
    } else if (event && event.formData.get("radio-1") && event.formData.get("radio-1").toLowerCase() == "professional") {
      window.location = "https://orca-golf.com/pages/lpga-professional";
    }
  },
  false
);

// $(document).ready(function() {
//   $(document).on("click",".shopify-payment-button__button",function() {
//        $(".wizard__submit").trigger("click");
//     });

//   $(document).on("click",".shopify-payment-button__more-options",function() {
//        $(".wizard__submit").trigger("click");
//   });
// });


// *********************************************************************
//      Hide and Display Personalization fields (Name and Logo) 
// *********************************************************************

$(document).ready(function () {
  for (var i = 0; i < 1; i++) {
    var defaultname = $(
      ".Product__OffScreen .OptionSelector:first-child .Popover__ValueListe .is-selected"
    ).text();
    if (defaultname == "YES") {
      $(".custom-my-name").css("display", "flex");
    } else {
      $(".custom-my-name").css("display", "none");
      $(".custom-my-name .Form__Input").val("");
    }
    var defaultlogo = $(
      ".Product__OffScreen .OptionSelector:nth-child(2) .Popover__ValueListe .is-selected"
    ).text();
    if (defaultlogo == "YES") {
      $(".custom-logo").css("display", "flex");
    } else {
      $(".custom-logo").css("display", "none");
      $(".custom-logo .Form__Input").val("");
    }
  }
  
  $(
    ".Product__OffScreen .OptionSelector:first-child .Popover__ValueList button"
  ).click(function () {
    var name = $(this).text();

    if (name == "YES") {
      $(".custom-my-name").css("display", "flex");
    } else {
      $(".custom-my-name").css("display", "none");
      $(".custom-my-name .Form__Input").val("");
    }
  });

  $(
    ".Product__OffScreen .OptionSelector:nth-child(2) .Popover__ValueList button"
  ).click(function () {
    var logo = $(this).text();

    if (logo == "YES") {
      $(".custom-logo").css("display", "flex");
    } else {
      $(".custom-logo").css("display", "none");
      $(".custom-logo .Form__Input").val("");
    }
  });
});